import { FormGroup, Label } from "reactstrap";
import NumberFormat from 'react-currency-format';

const PersonalData = (props) => {
  const { state } = props;
  return (
    <div className="border_top_detail col-md-12">
      <div className="profile_info col-md-12">
        <FormGroup className="details_profile_columned">
          <span className="datos-personales">Datos Personales CRM</span>
        </FormGroup>
      </div>
      <div className="profile_info col-md-4">
        <FormGroup className="details_profile_columned">
          <Label className="label_autofin" for="profile">Teléfono</Label>
          <span>
            {state.phone
              ? `${state.phone.code || ''} ${state.phone.number || ''}`
              : 'Sin teléfono'
            }
          </span>
        </FormGroup>
      </div>
      <div className="profile_info col-md-4">
        <FormGroup className="details_profile_columned">
          <Label className="label_autofin" for="profile">Correo</Label>
          <span>{state.email || state.clientEmail || 'Sin correo '}</span>
        </FormGroup>
      </div>
      <div className="profile_info col-md-4">
        <FormGroup className="details_profile_columned">
          <Label className="label_autofin" for="profile">Renta</Label>
          <span>
            <NumberFormat
              value={state.rentClient || '0'}
              displayType="text"
              decimalSeparator=","
              thousandSeparator="."
              prefix="$"
            />
          </span>
        </FormGroup>
      </div>
    </div>
  )
}

export default PersonalData;